import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { DocumentAccessTypesService } from '../document-access-types.service';
import { EditDocAccess } from '../document-access-types.interface';

@Component({
    selector: 'app-edit-document-access-types',
    templateUrl: './edit-document-access-types.component.html',
    styleUrls: ['./edit-document-access-types.component.scss']
})
export class EditDocumentAccessTypesComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        observatii: new FormControl(this.data.observatii, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditDocumentAccessTypesComponent>,
        private requestService: DocumentAccessTypesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, observatii } = this.form.value;
        const payload: EditDocAccess = {
            id: this.data.id,
            name,
            observatii
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
